import Vue from 'vue';
import VueRouter from 'vue-router';
import HomePage from '@/views/HomePage.vue';
// import FullScreenImageWrapper from '@/containers/FullScreenImageWrapper.vue';

Vue.use(VueRouter);

const routes = [
  // {
  //   path: '/',
  //   name: 'HomePage',
  //   component:  HomePage
  // },
  {
    path: '/',
    component: HomePage,
  },

  // {
  //   path: '/game/:act?',
  //   name: 'GamePage',
  //   component: () => import(/* webpackChunkName: "game" */ '@/views/GamePage.vue')
  // },
  // {
  //   path: '/sample',
  //   name: 'SamplePage',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "sample" */ '@/views/SamplePage.vue')
  // },
  {
    path: '*',
    redirect: '/',
  },
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
});

export default router;
